import { FC } from 'react'
import { useSelector } from 'react-redux'
import { UserAvatar, userSlice } from 'user'
import { getUserImage } from 'helpers/getUserImage'

const CurrentUserAvatar: FC = () => {
  const currentUser = useSelector(userSlice.selectors.selectCurrentUser)

  return (
    <UserAvatar
      name={currentUser?.displayName || ''}
      imgUrl={getUserImage({
        user: currentUser,
        type: 'avatar',
      })}
    />
  )
}

export default CurrentUserAvatar
